const MEDIA_BASE = `${import.meta.env.BASE_URL}media`;

export const media = (file: string): string => `${MEDIA_BASE}/${file}`;
